import React, { forwardRef } from 'react';
import css from '../../utils/css';
import { BaseButton, ButtonProps } from '../BaseButton';

/**
 * @deprecated  use `Button` from `genesis-core` instead
 */

export const PrimaryButton = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => (
    <BaseButton
      backgroundColor="primary.background.default"
      color="primary.text.default"
      ref={ref}
      css={css({
        ':hover': {
          backgroundColor: 'primary.background.hovered',
        },
        ':active': {
          backgroundColor: 'primary.background.pressed',
        },
      })}
      {...props}
    />
  )
);

PrimaryButton.displayName = 'PrimaryButton';
